import { Component } from '@angular/core'

@Component({
  selector: 'app-index',
  template: '',
  standalone: false
})
export class IndexComponent {}
